var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 87,
    viewBox: "0 0 143 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7616L20.4051 23.5766L19.5686 0.497739L0 12.7616ZM138.5 85C138.5 86.1045 139.395 87 140.5 87C141.605 87 142.5 86.1045 142.5 85H138.5ZM18.0427 14.1089C40.3818 13.4187 59.1176 13.3909 74.6701 14.7814C90.2345 16.173 102.459 18.9742 111.852 23.8439C121.18 28.6797 127.787 35.5904 132.1 45.3958C136.443 55.2676 138.5 68.1663 138.5 85H142.5C142.5 67.8997 140.42 54.3747 135.762 43.7852C131.074 33.1294 123.817 25.5412 113.693 20.2927C103.634 15.078 90.8174 12.2092 75.0263 10.7973C59.2235 9.38439 40.2896 9.4196 17.9191 10.1108L18.0427 14.1089Z",
    fill: "#FF671F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow2.0a4ac02513ea6ba0a7e9b30ae2c25c33.svg";